import "./QuestionsView.css";
import {
  Row,
  Card,
  Text,
  Divider,
  Collapse,
  Col,
  Spacer,
} from "@geist-ui/react";
import {
  FaRegArrowAltCircleUp,
  FaArrowAltCircleUp,
  // FaArrowAltCircleDown,
  FaRegArrowAltCircleDown,
  FaTrophy,
} from "react-icons/fa";

const RenderQuestions = ({ posts }) => {
  return (
    posts &&
    posts.map(({ id, title, shortDescription, longDescription }) => {
      return (
        <>
          <Collapse
            id={id}
            width="400"
            shadow
            title={title}
            subtitle={longDescription}
            className="collapseCard"
          >
            <Divider y={0} volume={0} />
            <Comments />
          </Collapse>
          <Spacer />
        </>
      );
    })
  );
};

const Comments = () => {
  return (
    <>
      <Divider y={3} volume={0} />
      <Card>
        <Card.Content>
          It is a long established fact that a reader will be distracted by the
          readable content of a page when looking at its layout. The point of
          using Lorem Ipsum is that it has a more-or-less normal distribution of
          letters, as opposed to using 'Content here, content here', making it
          look like readable English. Many desktop publishing packages and web
          page editors now use Lorem Ipsum as their default model text, and a
          search for 'lorem ipsum' will uncover many web sites still in their
          infancy. Various versions have evolved over the years, sometimes by
          accident, sometimes on purpose (injected humour and the like).
          <br />
          <br />
          Anyways, The mass of positron is equal to the mass of electron i.e.,
          0.000548756 amu. The exact value of the mass of the positron is about
          0.511 MeV/c2 or 9.11 x 10-31 kg.
        </Card.Content>
        <Card.Footer>
          <Row justify="end" className="trophyBar">
            <Col span={18}>
              <FaTrophy fill="orange" /> Top Voted
            </Col>
            <Col span={6}>
              <Text small className="upvoteBar">
                1.2k Upvotes
                <Spacer x={1} />
                <FaArrowAltCircleUp size="1.5em" fill="blue" />
                <FaRegArrowAltCircleDown size="1.5em" fill="grey" />
              </Text>
            </Col>
          </Row>
        </Card.Footer>
      </Card>
      <Divider y={2} volume={0} />
      <Card>
        <Card.Content>Multiply mass of electron with 10 :D</Card.Content>
        <Card.Footer>
          <Row justify="end" className="trophyBar">
            <Col span={18}></Col>
            <Col span={6}>
              <Text small className="upvoteBar">
                102 Upvotes
                <Spacer x={1} />
                <FaRegArrowAltCircleUp size="1.5em" fill="grey" />
                <FaRegArrowAltCircleDown size="1.5em" fill="grey" />
              </Text>
            </Col>
          </Row>
        </Card.Footer>
      </Card>
      <Divider y={2} volume={0} />
      <Card>
        <Card.Content>
          The mass of positron is equal to the mass of electron i.e.,
          0.000548756 amu. The exact value of the mass of the positron is about
          0.511 MeV/c2 or 9.11 x 10-31 kg.
        </Card.Content>
        <Card.Footer>
          <Row justify="end" className="trophyBar">
            <Col span={18}></Col>
            <Col span={6}>
              <Text small className="upvoteBar">
                10 Upvotes
                <Spacer x={1} />
                <FaRegArrowAltCircleUp size="1.5em" fill="grey" />
                <FaRegArrowAltCircleDown size="1.5em" fill="grey" />
              </Text>
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </>
  );
};

export default RenderQuestions;
